import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { RedirectComponent } from '../redirect-component';
import { useLocale } from 'hooks/use-locale';
import { joinUrl } from 'utility/utility';

export const NavigateWithParams = ({ to }) => {
  const [redirectUrl, setRedirectUrl] = useState();
  const params = useParams();
  let locale = useLocale();

  useEffect(() => {
    // replace all param placeholders with actual values
    to = to.replace(':locale', locale);
    to = to.replace(':lang', locale);
    to = to.replace(':count', locale);

    if (!to.match(/^\/?\w\w(-\w\w)?\/.*$/gim)) {
      to = joinUrl(locale, to);
    }

    for (const key in params) {
      to = to.replace(':' + key, params[key]);
    }
    setRedirectUrl(to);
  }, []);
  if (!redirectUrl) {
    return <></>;
  }
  return <RedirectComponent to={redirectUrl} />;
};
